import type { IntegrationDrive, IntegrationFolder } from '~/common/model/api/integration';

/**
 * Is IntegrationFolder.
 *
 * @param {unknown} folder Submit data.
 *
 * @returns {boolean} Submitted data is IntegrationFolder.
 */
export function isIntegrationFolder(folder?: unknown): folder is IntegrationFolder {
  if (!folder || typeof folder !== 'object') {
    return false;
  }

  return 'id' in folder && !!folder.id && 'driveId' in folder && !!folder.driveId;
}

/**
 * Is IntegrationDrive.
 *
 * @param {unknown} folder Submit data.
 *
 * @returns {boolean} Submitted data is IntegrationDrive.
 */
export function isIntegrationDrive(folder?: unknown): folder is IntegrationDrive {
  if (!folder || typeof folder !== 'object') {
    return false;
  }

  if ('id' in folder && !!folder.id && 'driveId') {
    if ('driveId' in folder) {
      return !folder.driveId;
    }

    return true;
  }

  return false;
}
